import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowDropDown } from "@mui/icons-material";
import { Menu } from "@mui/material";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../services/firebase";

const CategoriesModel = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);

  const goToCategory = (categoryId) => {
    navigate(`/categories/${encodeURIComponent(categoryId)}`);
  };

  useEffect(() => {
    const fetchCategories = async () => {
      const querySnapshot = await getDocs(collection(db, "categories"));
      const fetchedCategories = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCategories(fetchedCategories);
    };

    fetchCategories();
  }, []);
  return (
    <div className="relative group inline-block">
      <Link to="/" className="flex text-small hover:text-white">
        <ArrowDropDown fontSize="small" /> All Categories
      </Link>
      <div className="categories-modal">
        <div className="categories-arrow"></div>

        <div>
          <ul className=" text-black font-xs ">
            <li>
              <span className=" flex p-2 text-small font-semibold">
                <Menu /> All Categories
              </span>
            </li>

            {categories.map((category) => (
              <li>
                <button
                  key={category.id}
                  onClick={() => goToCategory(category.name)}
                  className="capitalize flex w-full text-start p-2 hover:text-white hover:bg-coffee"
                >
                  {category.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CategoriesModel;
